<script setup>
import { ref, computed, onMounted } from 'vue'
import { $router } from '@/router'
import { $bus } from '@/common/events'
import { dialog } from '@/common/dialog'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'
import Barcode from '@/components/Barcode.vue'
import EventLog from '@/components/EventLog.vue'

const last = ref("");
const log = ref("");

const logRecords = ref([
  { text: "18 23", time: "13:23:00", type: "command", direction: "outbound" },
  { text: "1234567890128", time: "13:23:00", type: "success", direction: "inbound" },
  { text: "12345670", time: "13:23:00", type: "success", direction: "inbound" },
  { text: "0, 4; 11", time: "13:23:00", type: "warning", direction: "inbound" },
  { text: "ERR", time: "13:23:00", type: "danger", direction: "inbound" },
]);

function addBarcode(value) {
  last.value = value;
  log.value += (log.value && log.value.trim().length ? "\r\n" : "") + value;
}

function clearLogs() {
  last.value = "";
  log.value = "";
}

function goBack() {
  try {
    $router.push({ name: "Admin" });
  }
  catch (err) {
    dialog(err);
  }
}

onMounted(() => {
  useTitle("Logger");
  useMenu("admin");
  useSubmenu(false);
  useTopBar(true);
});

//TODO: Find "insert" by barcode, search for inserts, odpri predal in zaveso po črtni kodi
</script>

<template>
  <div class="relative min-h-screen dark:bg-gray-900 dark:text-white p-5">
    <!-- <div><span class="text-lg font-bold dark:text-white">Barcode scanner test</span></div> -->
    <Breadcrumbs :items="['Home', 'Admin', 'Log viewer']"></Breadcrumbs>

    <!-- Top right corner -->
    <div class="fixed top-4 right-4 flex flex-row justify-items-strech space-x-2 z-10">
      <Button @click="clearLogs">{{ $t('generic.clear') }}</Button>
    </div>

    <div class="grid grid-cols-1 gap-2 w-full h-modal">

      <div class="h-full">
        <h6 class="w-full text-lg font-bold dark:text-white flex justify-between mt-8">
          <span>{{ $t('admin.log_viewer') }}</span>
        </h6>

        <!-- Logger -->
        <div class="mt-4 pb-20 w-full h-full">
          <Label>{{ $t('admin.list_of_messages') }}</Label>
          <div class="w-full h-full pb-4 mt-2">
            <EventLog :records="logRecords">
              <template #empty>
                {{ $t('generic.empty') }}
              </template>
            </EventLog>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<style scoped>
</style>
